import React, { FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { deskMobx, orderMobx } from 'restaurant'
import { thirdConfigG } from 'controllers/third'
import { getParams } from '@dt/fe-utils'
import { getPlatform, modalLayer, toast } from '@utils'
import { InputTableModal } from '../../modal'
import { Icon } from '@cps'
import './index.scss'

interface IProps {
}

const TableInput: FC<IProps> = () => {
  const { isWeixin, isAlipay } = getPlatform()
  const [canScan, setCanScan] = useState(true)
  const { ordersId, storeId, diningMode, tableAlias, eatType, scanType } = orderMobx.viewOrder

  const handleCreate = async (data: any) => {
    const res = await orderMobx.createTable({
      ordersId,
      ...data
    })
    if (res?.result) {
      toast({ message: i18n.t('result.inputTableCodeSuccess') })
      orderMobx.init(ordersId)
    } else {
      toast({ message: i18n.t('result.inputTableCodeFail') })
    }
  }

  const handleScan = () => {
    thirdConfigG().scan(async (str) => {
      if (str) {
        const { ct, b, s, t } = getParams({ url: str })
        if (!!ct && !!b && !!s && (!!t && ct === 'table') && Number(b) === Config.BRANDID && Number(s) === storeId) {
          if (!deskMobx.tableCodeToTableAliasMap[t]) await deskMobx.init(storeId)
          handleCreate({
            tableCode: t,
            tableAlias: deskMobx.tableCodeToTableAliasMap[t]
          })
        } else {
          toast({ message: i18n.t('menu.scanCodeTip') })
        }
      }
    })
  }

  const handleInputCode = () => {
    if (canScan) {
      if (isAlipay) {
        thirdConfigG().init(() => {
          handleScan()
        })
      } else {
        handleScan()
      }
    } else {
      modalLayer(InputTableModal, null, 'InputTableModal', true).then((tableAlias: any) => {
        handleCreate({
          tableAlias
        })
      }).catch(() => { })
    }
  }

  useEffect(() => {
    setCanScan(isAlipay || (isWeixin && !!thirdConfigG().isInited()))
  }, [])

  return (
    <>
      {
        diningMode === 2 && !tableAlias && eatType === 'dinein' && scanType === 'brand' ? (
          <div className='table-input' onClick={handleInputCode}>
            {canScan && <Icon icon='dicon' name='entry-newscancode0' />}
            {canScan ? i18n.t('result.scanTableCode') : i18n.t('result.inputTableCode')}
          </div>
        ) : null
      }
    </>
  )
}

export default observer(TableInput)
